module.exports = __webpack_public_path__ + "fonts/texgyrepagella-regular.1d43fcd3.otf";